import React from 'react';
import Menu from './../../components/menu';

export default function Cardapio(){
  return(
    <div>
      <Menu />
    </div>
  );
}